"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBubble = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("react");
const __1 = require("../../..");
const store_1 = require("../../../store");
const HostBubble_1 = require("../HostBubble");
const TextBubble = ({ message, onTypingEnd, skipAnimations, }) => {
    const chatbot = (0, store_1.useStoreState)((state) => state.chatbot.value);
    const [typing, setTyping] = (0, react_1.useState)(true);
    (0, react_2.useEffect)(() => {
        const typingDuration = (0, HostBubble_1.getTypingDuration)(skipAnimations, chatbot.settings.bubblesTypingSpeed, message);
        setTimeout(() => {
            setTyping(false);
            onTypingEnd();
        }, typingDuration);
    }, []);
    const parsedMessage = typeof message === "string"
        ? parseMessage(message, chatbot.variables)
        : (0, __1.parseVariables)(message.html, chatbot.variables);
    return (react_1.default.createElement("p", { style: {
            textOverflow: "ellipsis",
        }, className: "overflow-hidden content-opacity z-50 mx-4 my-2 whitespace-pre-wrap slate-html-container " +
            (typing ? "opacity-0 h-6" : "opacity-100 h-full"), dangerouslySetInnerHTML: {
            __html: parsedMessage,
        } }));
};
exports.TextBubble = TextBubble;
const parseMessage = (message, variables) => (0, __1.parseVariables)(parseLinks(message), variables);
const parseLinks = (message) => message.replace(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/g, '<a href="$1" target="_blank" class="underline">$1</a>');
//# sourceMappingURL=TextBubble.js.map